"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var group_exports = {};
__export(group_exports, {
  checkboxGroup: () => checkboxGroup,
  countsGroup: () => countsGroup,
  percentageDistributionGroup: () => percentageDistributionGroup,
  positiveCountsGroup: () => positiveCountsGroup,
  selectGroup: () => selectGroup
});
module.exports = __toCommonJS(group_exports);
var import_create = require("./create.js");
var import_rule = require("./rule/index.js");
function checkboxGroup(props) {
  const { fields, path, defaultValue } = props;
  return fields.map(
    ({ value, label, checkboxLabel }) => (0, import_create.checkbox)({
      label,
      checkboxLabel,
      path: [...path, value],
      defaultValue: defaultValue ?? false
    })
  );
}
function selectGroup(props) {
  const { path, fields, options, showValues, defaultValue, required } = props;
  return fields.map(
    ({ value, label, secondaryLabel, image, help }) => (0, import_create.select)({
      label,
      secondaryLabel,
      path: [...path, value],
      image,
      help,
      options,
      showValues,
      defaultValue,
      required
    })
  );
}
function countsGroup(props) {
  const { fields, path, units, defaultValue, singleBounds, totalBounds } = props;
  return fields.map(
    ({ value, label, secondaryLabel, image, help }) => (0, import_create.integerField)({
      label,
      secondaryLabel,
      path: [...path, value],
      units,
      bounds: singleBounds,
      defaultValue: defaultValue ?? 0,
      image,
      help,
      customRules: totalBounds == null ? [] : [(0, import_rule.totals)(path, totalBounds.minValue, totalBounds.maxValue, totalBounds.level)]
    })
  );
}
function positiveCountsGroup(props) {
  return countsGroup({
    ...props,
    singleBounds: props.singleBounds ?? (0, import_rule.minValue)(0),
    defaultValue: 0
  });
}
function percentageDistributionGroup(props) {
  return countsGroup({
    ...props,
    units: props.units ?? "%",
    singleBounds: props.singleBounds ?? (0, import_rule.bounds)(0, 100),
    totalBounds: props.totalBounds ?? (0, import_rule.bounds)(100, 100, "info"),
    defaultValue: props.defaultValue
  });
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  checkboxGroup,
  countsGroup,
  percentageDistributionGroup,
  positiveCountsGroup,
  selectGroup
});
//# sourceMappingURL=group.js.map
